var map = {
	"./PokesChs.js": [
		2470,
		[
			470
		]
	],
	"./PokesCht.js": [
		9623,
		[
			623
		]
	],
	"./PokesEn.js": [
		7767,
		[
			767
		]
	],
	"./PokesEs.js": [
		9412,
		[
			31
		]
	],
	"./PokesEsLa.js": [
		711,
		[
			711
		]
	],
	"./PokesFre.js": [
		4621,
		[
			621
		]
	],
	"./PokesGer.js": [
		6412,
		[
			412
		]
	],
	"./PokesIta.js": [
		6074,
		[
			74
		]
	],
	"./PokesJpn.js": [
		4362,
		[
			362
		]
	],
	"./PokesKor.js": [
		8962,
		[
			962
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1580;
module.exports = webpackAsyncContext;